import { queryKeyGetClientProfile } from '@entities/client/model';
import { client } from '@shared/api';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const GET_PLANS_KEY = 'get-plans';

export type TariffPeriod = 'MONTH' | 'YEAR' | 'QUARTER' | 'HALF_YEAR';

export interface Tariff {
  internalTransferCommissionExpr: string;
  exchangeCommissionExpr: string;
  withdrawCommissionExpr: string;
  depositCommissionExpr: string;
  cardOutCommissionExpr: string;
  cardInCommissionExpr: string;
  invoiceCommissionExpr: string;
  exchangeSameCurrencyCommissionExpr: string;
  withdrawSameCurrencyCommissionExpr: string;
  depositSameCurrencyCommissionExpr: string;
  cardOutSameCurrencyCommissionExpr: string;
  cardInSameCurrencyCommissionExpr: string;
  invoiceSameCurrencyCommissionExpr: string;
  cardDisburseCommissionExpr: string;
  cardDisburseSameCurrencyCommissionExpr: string;
  autoRefundThresholdAmount: number;
  autoRefundThresholdCurrency: string;
  cardInBadCurrencyCommissionExpr: string;
  cardOutBadCurrencyCommissionExpr: string;
  cardDisburseBadCurrencyCommissionExpr: string;
  id: string;
  period: TariffPeriod;
  name: string;
  monthlyPrice: number;
  cost: number;
  currency: string;
  createdAt: string;
}

interface GetTariffsResult {
  results: Tariff[];
  total: number;
}

export const useTariffs = () => {
  const query = useQuery<GetTariffsResult, AxiosError>({
    queryKey: [GET_PLANS_KEY],
    queryFn: () =>
      client
        .get('/client/tariffs', { params: { sort: 'asc', orderBy: 'cost' } })
        .then((res) => res.data),
  });

  return { tariffs: query.data?.results ?? [], ...query };
  // return { plans: mockPlans, ...query };
};

interface SubscribeToPlanPayload {
  tariffId: string;
}

export const useSubscribeToPlan = () => {
  return useMutation<Tariff, AxiosError, SubscribeToPlanPayload>({
    mutationFn: ({ tariffId }) =>
      client
        .post(`/client/tariffs/${tariffId}/subscribe`)
        .then((res) => res.data),
    mutationKey: queryKeyGetClientProfile,
  });
};
